module.exports = __webpack_public_path__ + "img/img_brand19.3b0a56bc.jpg";